export default __webpack_public_path__ + "static/media/amkr.20f6d9da.svg";